import moment from 'moment'
import {
  FUNCAO_ADM, FUNCAO_CONSULTOR, FUNCAO_PREMIUM, FUNCAO_GESTOR, VINCULAR_COLABORADOR,
  EXPORTAR_PDF, EXPORTAR_PDF_COMPLETO,
  EDITAR_EXIGENCIA, EXIBIR_EXIGENCIAS, PROPORCAO_VC, EDITAR_ALIMENTO_CQBAL,
  SALVAR_DIETA, SALVAR_PREDICAO, ATIVAR_DIETA, EXIBIR_RESUMO_DIETA,
  CRIAR_SUPLEMENTO, REFINAR_DIETA, REFINAR_PREDICAO,
  COMPARTILHAR_DIETA, COMPARTILHAR_PREDICAO, REOTIMIZAR_DIETA, LISTAR_ALIMENTOS_USUARIO,
  COMPATIBILIZAR_PREDICAO, COMPARTILHAR_COM_TODAS_PERMISSOES, GRAFICOS_DASHBOARD, GRAFICOS_FORMULACAO,
  ESCONDE_BOTAO_COMPATIBILIZAR, ESCONDE_BOTAO_EDITAR_EXIGENCIAS, ESCONDER_BOTAO_ENVIAR_ALIMENTO_ADAPTADO,
  RELATORIO_FINANCEIRO_COMPLETO, ENVIAR_ALIMENTO, ENVIAR_ALIMENTO_EMPRESA, AREA_EMPRESA,
  ENVIAR_ALIMENTO_ADAPTADO, DIETAS_ATIVAS_ILIMITADAS, ANUNCIO, CALCULAR_RACAO, FORMULAR_SUPLEMENTO, PERMITE_ACESSO_GRATUITO,
  AVISO_GRATUITO, PERMITE_CHECK_MINERAIS_COMUNS, EXIBIR_TABELA_REFERENCIA_BEZERROS,
  PERMITE_SELECIONAR_PADROES_EXIGENCIAS, EXIBIR_TABELA_RESUMIDA_COMPLETA, DADOS_ANIMAL_CARD,
  SUGESTAO_ALIMENTOS,
  COMPARAR_DIETAS,
  EXIBE_SUPLEMENTOS_CARD,
  MOSTRAR_PRECOS_SALVOS,
  ESCONDE_CUSTOS_PAGE
} from '../../utils/types'
import _ from 'lodash';

export const getAcessoModulo = (store, { user = null, modulo }) => {
  // Helper functions usando lodash
  const isNullOrEmpty = (value) => _.isNil(value) || _.isEmpty(value);
  const isUserValid = (user) => !isNullOrEmpty(user) && !_.isEqual(user, {});

  // Obter usuário de forma segura
  try {
    if (!isUserValid(user)) {
      if (store && !isNullOrEmpty(store)) {
        user = _.get(store, 'state.app.user');
      } else {
        user = JSON.parse(localStorage.getItem('user'));
      }
      if (!isUserValid(user)) return false;
    }
  } catch (_) {
    return false;
  }

  // Verificar permissões de administrador
  const isAdmin = _.get(user, 'permissao') === 0;
  if (!isAdmin && modulo === FUNCAO_ADM) return false;

  if (isAdmin) {
    if ([ANUNCIO, AVISO_GRATUITO].includes(modulo)) return false;
    const adminHiddenModules = [
      ESCONDE_BOTAO_EDITAR_EXIGENCIAS,
      ESCONDE_BOTAO_COMPATIBILIZAR,
      ESCONDER_BOTAO_ENVIAR_ALIMENTO_ADAPTADO
    ];
    return !adminHiddenModules.includes(modulo);
  }

  // Validar módulo
  if (isNullOrEmpty(modulo)) return false;

  const isEmpresaInativa = _.get(user, 'vinculadoEmpresaInativa', false);

  // Determinar tipos de usuário
  const isConsultor = _.get(user, 'consultor', false) ||
    (_.get(user, 'plano') &&
      moment(_.get(user, 'plano.data_final')).diff(new Date()) >= 0 &&
      _.get(user, 'plano.tipo') === 2);

  const isGestor = !isEmpresaInativa && (_.get(user, 'gestor', false) ||
    (_.get(user, 'emp_user') &&
      _.get(user, 'emp_user.acesso') === 0 &&
      (_.get(user, 'emp_user.autorizado') || parseInt(_.get(user, 'emp_user.autorizado')) === 1)));

  const isVinculado = !isEmpresaInativa && (_.get(user, 'gestor', false) ||
    _.get(user, 'vinculado', false) ||
    (_.get(user, 'emp_user') &&
      (_.get(user, 'emp_user.autorizado') || parseInt(_.get(user, 'emp_user.autorizado')) === 1) &&
      (_.get(user, 'emp_user.ativo') || parseInt(_.get(user, 'emp_user.ativo')) === 1)));

  const hasPremiumAccess = isGestor || isVinculado ||
    _.get(user, 'premium', false) ||
    _.get(user, 'premiumInfinito', false) ||
    isConsultor ||
    (_.get(user, 'plano') &&
      moment(_.get(user, 'plano.data_final')).diff(new Date()) >= 0 &&
      _.get(user, 'plano.tipo') === 1);

  const isPecuarista = _.get(user, 'pecuarista', false) &&
    (_.get(user, 'plano') &&
      moment(_.get(user, 'plano.data_final')).diff(new Date()) >= 0 &&
      _.get(user, 'plano.tipo') === 0);

  const isComum = !isConsultor && !isGestor && !isVinculado &&
    !_.get(user, 'premium', false) && !isPecuarista;

  // Verificar se plano foi revogado
  const isPlanRevoked = _.get(user, 'plano') && parseInt(_.get(user, 'plano.revogado')) === 1;
  if (isPlanRevoked) {
    if (isComum && [ANUNCIO, AVISO_GRATUITO].includes(modulo)) {
      return _.get(user, 'area_universitaria', true) === undefined ? true : !user.area_universitaria;
    }
    return false;
  }
  if (isComum && [ANUNCIO, AVISO_GRATUITO].includes(modulo)) return true;

  // Definir habilidades por tipo de usuário
  const habilidadesComum = [];

  const habilidadesPecuarista = _.union(
    habilidadesComum,
    [
      EXPORTAR_PDF, EXPORTAR_PDF_COMPLETO,
      PROPORCAO_VC, EDITAR_ALIMENTO_CQBAL, ENVIAR_ALIMENTO_ADAPTADO,
      SALVAR_DIETA, SALVAR_PREDICAO, ATIVAR_DIETA,
      CRIAR_SUPLEMENTO, REFINAR_DIETA, REFINAR_PREDICAO,
      RELATORIO_FINANCEIRO_COMPLETO, ENVIAR_ALIMENTO, COMPATIBILIZAR_PREDICAO,
      COMPARTILHAR_DIETA, COMPARTILHAR_PREDICAO, LISTAR_ALIMENTOS_USUARIO,
      DIETAS_ATIVAS_ILIMITADAS,
      ENVIAR_ALIMENTO_ADAPTADO,
      ESCONDE_BOTAO_EDITAR_EXIGENCIAS,
      EXIBIR_EXIGENCIAS, EXIBIR_RESUMO_DIETA,
      PERMITE_CHECK_MINERAIS_COMUNS, EXIBIR_TABELA_REFERENCIA_BEZERROS,
      PERMITE_SELECIONAR_PADROES_EXIGENCIAS, EXIBIR_TABELA_RESUMIDA_COMPLETA,
      COMPARAR_DIETAS, EXIBE_SUPLEMENTOS_CARD, DADOS_ANIMAL_CARD, SUGESTAO_ALIMENTOS, ESCONDE_CUSTOS_PAGE
    ]
  );
  const habilidadesPecuaristaExclusiva = [ESCONDE_BOTAO_EDITAR_EXIGENCIAS, ESCONDE_CUSTOS_PAGE];

  const habilidadesPremium = _.union(
    _.difference(habilidadesPecuarista, habilidadesPecuaristaExclusiva),
    [
      FUNCAO_PREMIUM, EXPORTAR_PDF, EXPORTAR_PDF_COMPLETO,
      EDITAR_EXIGENCIA, PROPORCAO_VC, EDITAR_ALIMENTO_CQBAL,
      SALVAR_DIETA, SALVAR_PREDICAO, ATIVAR_DIETA,
      CRIAR_SUPLEMENTO, REFINAR_DIETA, REFINAR_PREDICAO,
      RELATORIO_FINANCEIRO_COMPLETO, ENVIAR_ALIMENTO, ENVIAR_ALIMENTO_ADAPTADO,
      COMPARTILHAR_DIETA, COMPARTILHAR_PREDICAO, COMPATIBILIZAR_PREDICAO,
      COMPARTILHAR_COM_TODAS_PERMISSOES,
      GRAFICOS_DASHBOARD, GRAFICOS_FORMULACAO, REOTIMIZAR_DIETA,
      CALCULAR_RACAO, FORMULAR_SUPLEMENTO, MOSTRAR_PRECOS_SALVOS
    ]
  );
  const habilidadesPremiumExclusiva = [];

  const habilidadesConsultor = _.union(_.difference(habilidadesPremium, habilidadesPremiumExclusiva), [FUNCAO_CONSULTOR]);
  const habilidadesConsultorExclusiva = [];

  const habilidadesVinculado = _.union(_.difference(habilidadesPremium, habilidadesPremiumExclusiva), [AREA_EMPRESA, FUNCAO_CONSULTOR]);
  const habilidadesVinculadoExclusiva = [];

  const habilidadesGestor = _.union(
    _.difference(habilidadesVinculado, habilidadesVinculadoExclusiva),
    [FUNCAO_GESTOR, VINCULAR_COLABORADOR, AREA_EMPRESA, ENVIAR_ALIMENTO_EMPRESA]
  );

  // Verificar acesso baseado no tipo de usuário
  if (isComum) {
    if (modulo === PERMITE_ACESSO_GRATUITO) {
      return !process.env.VUE_APP_ACESSO_GRATUITO || parseInt(process.env.VUE_APP_ACESSO_GRATUITO) === 1;
    }
    return habilidadesComum.includes(modulo);
  }

  // Retornar baseado na hierarquia de permissões
  const permissionHierarchy = [
    { condition: isGestor, abilities: habilidadesGestor },
    { condition: isVinculado, abilities: habilidadesVinculado },
    { condition: isConsultor, abilities: habilidadesConsultor },
    { condition: isPecuarista, abilities: habilidadesPecuarista },
    { condition: hasPremiumAccess, abilities: habilidadesPremium }
  ];

  const userPermission = _.find(permissionHierarchy, ({ condition }) => condition);
  return userPermission ? userPermission.abilities.includes(modulo) : false;
};
